<template>
  <footer class="footer">
    <div class="md-layout">
      <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100"></div>
      <div class="md-layout-item md-large-size-50 md-xlarge-size-50 md-medium-size-50 md-small-size-100 text-right">
        <div class="copyright text-right">
          &copy;&nbsp;{{ new Date().getFullYear() }}&nbsp;
          <a :href="$store.getters.config.company_url" target="_blank">{{ $store.getters.config.company }}</a>&nbsp;
          <span v-if="$store.getters.config.version">{{ $store.getters.config.version }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
